import {nop} from '~/utils/functional'

export function preventDefault(fun = nop) {
  return e => {
    e.preventDefault()
    e.stopPropagation()
    fun()
  }
}
